import { getRequestV2 } from '../../methods';

const getCurrencies = () => getRequestV2('currencies');

const currencies = {
  getCurrencies,
};

export default currencies;
